export default __webpack_public_path__ + "static/media/resources_TEB-2x.c3b45084.png";